import { ApiResponse } from '@arrived/models';

export const unwrapApiResponse = <T>(response: ApiResponse<T>) => {
  if (response.data) {
    return response.data;
  }

  throw response.error;
};
